<template>
  <div style="margin: 4px 16px 16px;">
    <div class="content-input" style="margin-bottom: 8px;">
      <div class="content-input-left">
        <div class="dialog-input-item">
          <label>添加门店</label>
          <el-select v-model="shopId" placeholder="选择门店" class="select-item">
            <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <label>复用门店</label>
          <el-select v-model="reuseShopId" placeholder="选择复用门店" class="select-item" @change="reuseShopChange">
            <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="content-input-right">
        <div class="dialog-input-btn">
          <el-button type="primary" :disabled="this.idArray.length == 0 || !this.shopId" @click="reuse">一键复用</el-button>
        </div>
      </div>
    </div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%; "
        v-loading="listLoading"
        size="default"
        border
        @selection-change="selsChange"
        @header-click="selsAll"
        @cell-click="toggleSelection"
    >
      <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
      <el-table-column property="createTime" label="卫生打卡类型">
        <template #default="scope">
          {{scope.row.type == 1?'每日卫生打卡':scope.row.type == 2?'每周卫生打卡':scope.row.type == 3?'每月卫生打卡':'' }}
        </template>
      </el-table-column>
      <el-table-column property="area" label="区域"/>
      <el-table-column property="location" label="位置" />
      <el-table-column property="" label="示例图">
        <template #default="scope">
          <div v-if="scope.row.standardImgList.length > 0" class="cursor" @click="userImgList(scope.row)">
            <el-image class="item-img" fit="cover" :src="scope.row.standardImgList[0].smallImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
          </div>
          <div v-else>
            <el-image class="item-img" fit="cover"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 12px">共 {{this.pageDataList.length}} 项</div>
    <!--分页-->
<!--    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalRow" style="text-align:right;margin-top: 24px;">-->
<!--    </el-pagination>-->
  </div>
</template>

<script>
import {getFormData, postFormData} from '@/api/api';
import {listShopStandard, reuseStandard} from '@/api/url';
import SearchComponents from "@/components/SearchComponents";
import DatePickerRange from "@/components/DatePickerRange";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
export default {
  props: {
    value: Object
  },
  components: {DatePickerRange, SearchComponents},
  data() {
    return {
      pageDataList: [],
      id: this.value.id,
      userForm: this.value.userForm,
      pageType: this.value.pageType,
      totalRow: 0,
      pageSize: 20,
      currentPage: 1,
      listLoading: false,
      searchLoading: false,


      shopIdArray: [],
      shopIdArr:[],
      shopId: '',
      reuseShopId: '',

      idArray: [],

    }
  },
  methods: {

    userImgList(row) {
      let _title = '';
      _title = '图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: row.standardImgList,
          id: row.id,
          width: 908,
          from: 6
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    toggleSelection(row, column, cell, event) {
      if (column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
    },


    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    reuseShopChange() {
      this.getPage()
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      // param['pageNum'] = page;
      param['id'] = this.reuseShopId;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(listShopStandard, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          this.pageDataList = data['data'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    reuse() {
      let param = {};
      param['idArr'] = this.idArray;
      param['shopId'] = this.shopId;
      postFormData(reuseStandard, param).then(data => {
        let {msg, code } = data;
        if(code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          this.$emit('confirm')
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    },


  },
  mounted() {
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
    this.reuseShopId = this.shopIdArray[0].id
    this.getPage();
  }
}
</script>

<style>
.item-img {
  width: 80px;
  height: 80px;
}
</style>
